import { createReducer, on } from "@ngrx/store";
import { ParameterGroup } from "../../models/parameter-group";
import { loadParameterGroupByIdAct } from "./parameters.actions";

const parameterGroup: ParameterGroup = new ParameterGroup();

export const parameterGroupReducer = createReducer(
    {
        parameterGroup,
        loading: true
    },
    on(loadParameterGroupByIdAct, (state, { parameterGroup }) => ({
        parameterGroup: { ...parameterGroup },
        loading: false
    })),
);